import { render, staticRenderFns } from "./NewGraduate.vue?vue&type=template&id=862f4ebc&scoped=true&"
import script from "./NewGraduate.vue?vue&type=script&lang=js&"
export * from "./NewGraduate.vue?vue&type=script&lang=js&"
import style0 from "./NewGraduate.vue?vue&type=style&index=0&id=862f4ebc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "862f4ebc",
  null
  
)

export default component.exports